function headerScroll(){
    if($(window).scrollTop()){
        $('header.site-header').addClass('scroll')
    }else{
        $('header.site-header').removeClass('scroll')
    }
}

headerScroll()

$(window).scroll(headerScroll);

$(document).on('click', '.open-menu', function(){
    $('.mobile-menu').addClass('show')
})

$(document).on('click', '.close-menu', function(){
    $('.mobile-menu').removeClass('show')
})

$(document).click(function (e) {
    var menu = $('.menu-group')

    if ( !menu.is(e.target) && menu.has(e.target).length === 0) {
        $('.mobile-menu').removeClass('show')
    }
})




const toggle_menu = document.getElementById('toggle-menu');
toggle_menu.addEventListener('click', function(){
    $('.mobile-menu').stop().slideToggle(300);
    $('.toggle-menu').toggleClass('toggle');
});
  

$(document).on('click', '.close-menu', function(){
    $('.mobile-menu').stop().slideUp(300)
})

$(document).on('click', '.open-btn', function(){
    $('.filter-side').addClass('open');
})  

$(document).on('click', '.close-btn', function(){
    $('.filter-side').removeClass('open');
})  